import { Grid, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from '../../contexts/translation';
import { LocalUserInputs } from '../../types/app/localUser.types';
interface Props {
  onSubmit: SubmitHandler<LocalUserInputs>;
  defaultValues?: LocalUserInputs;
  isReadOnly?: boolean;
}

export function LocalUserPasswordChangeForm({ onSubmit, defaultValues, isReadOnly }: Props) {
  const { t } = useTranslation();
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm<LocalUserInputs>();

  const [tmpPassword1, setTmpPassword1] = useState<string>();
  const [tmpPassword2, setTmpPassword2] = useState<string>();

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues]);

  useEffect(() => {
    if (!tmpPassword1 && !tmpPassword2) return;
    if (tmpPassword1 !== tmpPassword2) {
      setError('password', {
        type: 'custom',
        message: t('page.local-user.passwords-do-not-match'),
      });
    } else {
      clearErrors();
    }
  }, [tmpPassword1, tmpPassword2]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              label={t('page.local-user.edit-input-label-4')}
              onChange={(e: any) => {
                if (e.target.value) setTmpPassword1(e.target.value);
              }}
              type={'password'}
              error={Boolean(errors.password)}
              helperText={errors.password?.message}
              disabled={isReadOnly}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              label={t('page.local-user.edit-input-label-5')}
              {...register('password', {
                onChange: (e: any) => {
                  if (e.target.value) setTmpPassword2(e.target.value);
                },
              })}
              type={'password'}
              error={Boolean(errors.password)}
              helperText={errors.password?.message}
              disabled={isReadOnly}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={Boolean(errors.password)}
              fullWidth
            >
              {t('general.action-buttons.change-password')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
